import Modal from 'react-responsive-modal';
import styles from './style.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  playerName: string;
}

export function ModalBonusPrimeiroAcesso({ open, onClose, playerName }: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      center
      classNames={{
        modal: styles.modal,
        closeButton: styles.closeButton,
      }}
    >
      <div className={styles.inner}>
        <div className={styles.trophy}>🏆</div>
        <p className={styles.heading}>
          Parabéns, <span className={styles.username}>@{playerName}</span>!
        </p>
        <p className={styles.youWon}>Você ganhou</p>
        <p className={styles.prize}>R$ 1.000</p>
        <p className={styles.body}>
          Para resgatar, <strong>comece a indicar clientes.</strong>
          <br />
          Você vai receber seu bônus junto com
          <br />
          <strong>sua 1ª comissão!</strong>
        </p>
        <button className={styles.btn} onClick={onClose}>
          Começar agora
        </button>
      </div>
    </Modal>
  );
}
